import { render, staticRenderFns } from "./goods_image_mask.vue?vue&type=template&id=3f7ba07f&scoped=true"
import script from "./goods_image_mask.vue?vue&type=script&lang=js"
export * from "./goods_image_mask.vue?vue&type=script&lang=js"
import style0 from "./goods_image_mask.vue?vue&type=style&index=0&id=3f7ba07f&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f7ba07f",
  null
  
)

export default component.exports